export enum TipoFiltroOrdine {
  noFiltro = 0,
  myRisorse = 1,
  myLavorazioni = 2,
  myRisorseLavorazioni = 3
}

export const TIPO_FILTRO_ORDINE = [
  { value: TipoFiltroOrdine.noFiltro, label: 'No filtro' },
  { value: TipoFiltroOrdine.myRisorse, label: 'Risorse personali' },
  { value: TipoFiltroOrdine.myLavorazioni, label: 'Lavorazioni personali' },
  { value: TipoFiltroOrdine.myRisorseLavorazioni, label: 'Risorse e lavorazioni'}
];
